import React from 'react'
import { connect } from 'react-redux'

import { api, path } from '../lib'
import FP2 from '../lib/fp'
import pjson from '../../package.json'

import PlanField from '../components/PlanField'

class Plan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      minPenalty: 200,
      penaltyRate: 0.5,
      rates: [],
      reason: '',
      startAt: 0,
      PP: [0, 0],
      VP: [-1, -1],
      loading: false,
      message: '',

      plans: []
    }
  }

  async componentDidMount() {
    const result = await api.nex.get(path.API_PLANS, {
      params: {
        app: encodeURIComponent(pjson.name),
        dn: encodeURIComponent(await FP2),
        dm: encodeURIComponent(navigator.userAgent),
        vn: pjson.version,
        ts: Date.now(),
        tz: new Date().getTimezoneOffset() * -1,
        cn: navigator.language.split('-')[1] ? navigator.language.split('-')[1] : navigator.language,
      },
      headers: {
        Authorization: `Bearer ${this.props.user.token}`
      }
    })

    const { plans } = result.data

    this.setState({
      plans,
    })

  }

  onNameChange = e => {
    this.setState({
      name: e.target.value,
    })
  }

  onMPChange = e => {
    this.setState({
      minPenalty: e.target.value,
    })
  }

  onPRChange = e => {
    this.setState({
      penaltyRate: e.target.value
    })
  }

  onReasonChange = e => {
    this.setState({
      reason: e.target.value
    })
  }

  onDateChange = e => {
    this.setState({
      startAt: new Date(e.target.value).setHours(0,0,0,0)
    })
  }

  onPP0Change = e => {
    const { PP } = this.state
    PP[0] = e.target.value
    this.setState({
      PP
    })
  }

  onPP1Change = e => {
    const { PP } = this.state
    PP[1] = e.target.value
    this.setState({
      PP
    })
  }

  onVP0Change = e => {
    const { VP } = this.state
    VP[0] = e.target.value
    this.setState({
      VP
    })
  }

  onVP1Change = e => {
    const { VP } = this.state
    VP[1] = e.target.value
    this.setState({
      VP
    })
  }

  onSubmit = async () => {
    this.setState({
      loading: true,
    })
    const data = {
      app: pjson.name,
      dn: await FP2,
      dm: navigator.userAgent,
      vn: pjson.version,
      ts: Date.now(),
      tz: new Date().getTimezoneOffset() * -1,
      cn: navigator.language.split('-')[1] ? navigator.language.split('-')[1] : navigator.language,
      name: this.state.name,
      type: 'month',
      country: 'TW',
      currency: 'TWD',
      startAt: this.state.startAt,
      planType: 'rates',
      minPenalty: +this.state.minPenalty,
      penaltyRate: +this.state.penaltyRate,
      rates: Array.from({ length: 2 }).map((v, i) => {
        return {
          periodPrice: +this.state.PP[i],
          validPeriods: +this.state.VP[i],
        }
      }).filter(p => p.validPeriods >= 0),
      reason: this.state.reason
    }
    console.log(this.props.user.token)
    api.nex.post(path.PRIVATE_PLANS, data, {
      headers: {
        Authorization: `Bearer ${this.props.user && this.props.user.token}`
      }
    }).then(res => {
      const { planId } = res.data

      this.setState({
        loading: false,
        message: `Add plan success - ${planId}`
      })
    }).catch(error => {
      switch (error.response.data.error) {
        case 'api/invalid-parameters':
          this.setState({
            loading: false,
            message: 'invalid-parameters',
          })
        break
        default:
          this.setState({
            loading: false,
            message: error.message,
          })
        break
      }
    })
  }

  render() {
    
    return (
      <PlanField plans={this.state.plans} onSubmit={this.onSubmit} message={this.state.message} loading={this.state.loading} onVP1Change={this.onVP1Change} onVP0Change={this.onVP0Change} onPP0Change={this.onPP0Change} onPP1Change={this.onPP1Change} onRatesChange={this.onRatesChange} onDateChange={this.onDateChange} onNameChange={this.onNameChange} onMPChange={this.onMPChange} onPRChange={this.onPRChange} onReasonChange={this.onReasonChange}/>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

export default connect(
  mapStateToProps
)(Plan)


// WEBPACK FOOTER //
// ./src/containers/Plan.jsx